var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.50696 9.90137L2.50135 9.99856C2.50135 10.4259 2.82305 10.7781 3.2375 10.8263L3.33469 10.8319H14.653L11.0786 14.4095C10.7783 14.71 10.7553 15.1827 11.0096 15.5095L11.0789 15.588C11.3794 15.8883 11.8521 15.9113 12.179 15.657L12.2574 15.5876L17.2834 10.5573L17.3351 10.4943L17.3733 10.4381L17.4289 10.3325L17.4677 10.2235L17.4886 10.1272L17.498 10.0263L17.4954 9.92672L17.483 9.83808L17.4579 9.74106L17.4205 9.64599L17.388 9.58341L17.3517 9.52604L17.318 9.48056L17.2834 9.43982L12.2574 4.40947C11.9321 4.08394 11.4045 4.08379 11.0789 4.40913C10.7784 4.70945 10.7552 5.18214 11.0093 5.50912L11.0786 5.58764L14.6547 9.16522H3.33469C2.90732 9.16522 2.5551 9.48692 2.50696 9.90137L2.50135 9.99856L2.50696 9.90137Z"}));
}

Arrow.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Arrow;

Arrow.default = Arrow;
